export { vi } from '@payloadcms/translations/languages/vi'
